skrilla.directive('dailyFinancialReconciliation', function () {
    return {
        templateUrl: 'directives/dailyFinancialReconciliation/dailyFinancialReconciliation.html',
        scope: { },
        controller: function ($scope, searchService, paginationService, queryService, dateService, currencyService, productFeeReportService) {
            $scope.currencies = currencyService.getCurrencies()
            $scope.reportNames = [
                "AUD_DAILY_RECONCILIATION",
                "USD_DAILY_RECONCILIATION",
                "EUR_DAILY_RECONCILIATION",
                "NZD_DAILY_RECONCILIATION",
                "CAD_DAILY_RECONCILIATION",
            ]
            $scope.pageKey = "reconciliationsDirective";
            $scope.reset = function () {
                $scope.query = {
                    limit: 50,
                    reportName: "AUD_DAILY_RECONCILIATION"
                };
            };
            $scope.reset();

            $scope.pageKey = "financials";

            $scope.tableData = {
                columns: [
                    {title:"Credit Card Deposits ", field: "ccDeposits", filter: {name: "dollarOrSkrilla", args: [$scope.currency]}},
                    {title:"Credit Card Refunds", field: "ccRefunds", filter: {name: "dollarOrSkrilla", args: [$scope.currency]}},
                    {title:"PAYID Deposits", field: "payIdDeposits", filter: {name: "dollarOrSkrilla", args: [$scope.currency]}},
                    {title:"PAYID Refunds", field: "payIdRefunds", filter: {name: "dollarOrSkrilla", args: [$scope.currency]}},
                    {title:"POli Deposits", field: "poliDeposits", filter: {name: "dollarOrSkrilla", args: [$scope.currency]}},
                    {title:"Chargebacks Received", field: "chargeBacks", filter: {name: "dollarOrSkrilla", args: [$scope.currency]}},
                    {title:"Cash", field: "cash", filter: {name: "dollarOrSkrilla", args: [$scope.currency]}},
                    {title:"Betting Winnings", field: "bettingWinnings", filter: {name: "dollarOrSkrilla", args: [$scope.currency]}}, {title:"Promotion", field: "promotion", filter: {name: "dollarOrSkrilla", args: [$scope.currency]}},
                    {title:"User Promotion", field: "promotionUser", filter: {name: "dollarOrSkrilla", args: [$scope.currency]}},
                    {title: "DFS Holding", field: "dfsHolding", filter: {name: "dollarOrSkrilla", args: [$scope.currency]}},
                    {title:"Betting Revenue", field: "bettingRevenue", filter: {name: "dollarOrSkrilla", args: [$scope.currency]}},
                    {title:"Available", field: "available", filter: {name: "dollarOrSkrilla", args: [$scope.currency]}},
                    {title:"Holding", field: "holding", filter: {name: "dollarOrSkrilla", args: [$scope.currency]}},
                    {title:"Withdrawal", field: "withdrawal", filter: {name: "dollarOrSkrilla", args: [$scope.currency]}},
                    {title:"CC Verification", field: "ccVerificationHolding", filter: {name: "dollarOrSkrilla", args: [$scope.currency]}},
                    {title:"Finance Adjustments", field: "financeAdjustments", filter: {name: "dollarOrSkrilla", args: [$scope.currency]}},
                    {title: "Fees", field: "fees", filter: {name: "dollarOrSkrilla", args: [$scope.currency]}},
                    {title: "Cash Deposits", field: "cashDeposits", filter: {name: "dollarOrSkrilla", args: [$scope.currency]}},
                    {title: "Exchange Rate", field: "fromAudFxRate"},

                    {title:"End Time", field: "endTime", filter:{name: 'dateTimeFormatter'}},
                ],
                rows: {orderBy: "-createdAt"},
                isSkrillaTable: true
            }


            $scope.search = function() {
                searchService.get(`reports/dailyFinancialsView/${$scope.query.reportName}?limit=${$scope.query.limit}`, null, true).then(function (response) {
                    $scope.csv = response.data.csv;
                    $scope.tableDataNew = productFeeReportService.buildTableForEntries($scope.csv);
                })
            }
            $scope.search();


        }
    };
});
